module.exports = __webpack_public_path__ + "assets/img/33_778.ed02846f.jpg";